import { anyPass } from 'ramda';
import { isMediaFromWix, isSiteFiles, isTrash, isVisitorsUploads } from '../../../utils/media-manager-sdk/sources';
import { MainSource } from '../../../constants/Source';
import { decodePublicMediaFolderId } from '../../../utils/hoc/withPublicMedia/utils';

export const convertToSubmitFolderId = (folderId: string, source: MainSource): string => {
  if (anyPass([isSiteFiles, isTrash, isVisitorsUploads])(source)) {
    return folderId;
  }

  if (isMediaFromWix(source)) {
    return decodePublicMediaFolderId(folderId).subCategoryId;
  }

  return null;
};
